var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAruba(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4189dd",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d616",
    d: "m0 15 30 .08v1.97H0v1.98h30V21H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.25 1.19a.26.26 0 0 1 .5 0l.96 3.1 3.1.96c.23.07.25.36.07.47l-.07.03-3.1.96-.96 3.1a.27.27 0 0 1-.47.07l-.03-.07-.96-3.1-3.1-.96a.27.27 0 0 1-.07-.47l.07-.03 3.1-.96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "m6.5 2.5-.67 2.17a.2.2 0 0 1-.16.16L3.5 5.5l2.17.67q.08.03.14.1l.02.06.67 2.17.67-2.17q.03-.08.1-.14l.06-.02L9.5 5.5l-2.17-.67a.2.2 0 0 1-.13-.1l-.03-.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAruba);
export default __webpack_public_path__ + "static/media/aruba.1bb29cdd45a265985b68ebab3c069297.svg";
export { ForwardRef as ReactComponent };